import React, { useState ,useEffect} from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import StarRateIcon from '@material-ui/icons/StarRate';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Divider from '@material-ui/core/Divider';
 import { getReviews} from '../../actions/fooditems';

import Avatar from '@material-ui/core/Avatar';
import ImageIcon from '@material-ui/icons/Image';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

const Rating = withStyles(()=>({
  starContainer: {
    marginLeft: '10px',
    marginRight: '10px'
  },
  rating: {
    marginRight: '0px'
  },
  active: {
    fill: '#fad043',
  },
  default: {
    fill: '#c6cad0'
  },
}))(({ classes, rating, fontSize = 'medium' }) => {
  return (<div className={classes.starContainer}>
    { new Array(5).fill(0).map((item, index)=> {
      const starClass = rating > index ? classes.active : classes.default;
      return (<StarRateIcon fontSize={fontSize} classes={{ root: `${classes.rating} ${starClass}` }}/>)
    }) }
  </div>)
});

const ReviewRating = ({ classes,TRating,RatingsAr }) => {
   let rsum = RatingsAr.reduce((sum, x) => sum + x);
   return (
    <div className={classes.container1}>
      <div className={classes.container}>
      {
        [5,4,3,2,1].map((item,index)=> {
          return (<div className={classes.star}>
            <strong>{ item } Star</strong>
            <Rating classes={classes} rating={item}/>
             { RatingsAr[index]!=0 ?
            Math.round((RatingsAr[index]/rsum)*100):"0"
            } %
          </div>
          )
        })
      }
      </div>
      <div className={classes.finalRating}>
        <Typography variant="h3"> {TRating} </Typography>
        <Typography variant="paragraph" className="text-center"> out of 5 </Typography>
      </div>
    </div>
  )
};

const styles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '50px'
  },
  container1: {
    display: 'flex'
  },
  star: {
    display: 'flex',
    alignItems: 'center'
  },
  
  finalRating: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});

const Ratings = withStyles(styles)(ReviewRating);

const reviewStyles = () => ({

});

const Reviews = withStyles(()=>(
  {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '24px',
    justifyContent: 'space-between'
  },
  listItem: {
    width: '49%',
    paddingTop: '10px',
    paddingBottom: '10px',
    display: 'flex',
    flexWrap: 'wrap',
    '&:nth-child(odd)': {
      paddingRight: '10px',
      borderRight: '1px solid #c6cad0',
    }
  },
  listRoot: {
    padding: '8px 0'
  },
  dividerRoot: {
    width: '100%',
    marginTop: '10px'
  }
}))(({ classes,rev }) => {
 //[1,2,3,4, 5, 6, 7, 8]
   return (<div>
    <div className={classes.root}>
       { rev && rev.map((s,t)=> (<div className={classes.listItem}>
        <Avatar alt="Remy Sharp" src={s.dpUrl ? s.dpUrl : ""} className={classes.profile} />
        <div className={'ml-3'}>
          <Typography variant="subtitle2">{s.name ? s.name : ""}</Typography> 
          <Typography variant="span">{s.date ? s.date : ""} {s.time ? s.time : ""}</Typography>
        </div>
        <div className={'ml-auto'}>
          <Rating rating={s.rating ? s.rating : ""} fontSize={'small'}/>
        </div>
         <div className={'mt-2'}>
          {s.comments ? s.comments : ""}
         </div>
        <Divider classes={{ root: classes.dividerRoot }}/>
      </div>))}
    </div>
  </div>)
})

const ReviewsAndRatings = (props) => {
  const classes = props.classes;
  let rid = props.id;
  let revparam = props.revfun;
  let TodalRating = props.totalrating;
  let ratingAr = props.rating;
  const [reviewdet, setReviewDet] = useState([]);

      useEffect(()=>{
      getReviews(rid,revparam).then((response)=>{
          //console.log("response",(response.data.details.reviews).length);
        setReviewDet((response.data.details.reviews).length === 0 ? '' : response.data.details.reviews);
 
     })
    }, []);
  return (<Card className={`${classes.root}`}>
    <CardContent>
      <h2 className={'mb-3'}> <strong>Reviews & Ratings</strong> </h2>
      <Ratings TRating = {TodalRating} RatingsAr = {ratingAr}/>
      <Reviews rev = {reviewdet}/>
    </CardContent>
  </Card>
  )
};

export default ReviewsAndRatings;
